import React from 'react';
import PolicyPageLayout from '../components/PolicyPageLayout';

const FaqPage = () => {
  return (
    <PolicyPageLayout title="Frequently Asked Questions">
      
      <h2>Ordering & Products</h2>
      
      <h4>How do I select a specific saree or dress?</h4>
      <p>
        Each of our products has a unique code. Simply enter this code into the search bar on our website to find the exact item you're looking for.
      </p>
      
      <h4>How do I place an order?</h4>
      <p>
        Explore our collections, select your desired items, and add them to your cart. When you're ready, proceed to checkout, enter your billing and shipping details, and make the payment. Once your order is placed, you will receive a confirmation call from our team within 24 hours. We will only dispatch your order after this confirmation.
      </p>

      <h2>Payments</h2>

      <h4>What payment methods do you accept?</h4>
      <p>
        We accept all major credit and debit cards, as well as digital wallets like Google Pay and PhonePe through our secure payment gateway.
      </p>

      <h4>Do you offer Cash on Delivery (COD)?</h4>
      <p>
        Currently, we only accept prepaid orders. We do not offer a Cash on Delivery option.
      </p>

      <h2>Shipping & Delivery</h2>

      <h4>How much does shipping cost?</h4>
      <p>
        Shipping costs vary based on your delivery address and the shipping method you choose. The final shipping amount will be calculated and displayed at checkout before you complete your payment.
      </p>

      <h4>What should I do if my order arrives damaged?</h4>
      <p>
        We take great care in packing every order. However, if your item arrives damaged, please record a complete, unedited unboxing video clearly showing the damage. We cannot process any exchanges or refunds for damaged items without this video proof. Please contact our customer support with the video to resolve the issue.
      </p>
      
      <h2>Orders & Support</h2>

      <h4>Can I modify or cancel my order?</h4>
      <p>
        Yes, you can request to modify or cancel your order within 24 hours of placing it. Please contact our customer support team as soon as possible to make changes.
      </p>

      <h4>What are your customer support hours?</h4>
      <p>
        Our team is available to help you from <strong>Monday to Saturday, 10 AM to 5 PM (IST)</strong>.
      </p>

    </PolicyPageLayout>
  );
};

export default FaqPage;